import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

/**
 * Carga diferida de la libreria de iconos de venue. Los 40 SVG (~160 kB) quedan fuera del bundle
 * inicial y la promesa cacheada evita descargas repetidas entre instancias.
 */
@Injectable({
  providedIn: 'root'
})
export class VenueIconLibraryService {

  // STATE
  private readonly _unavailable: WritableSignal<boolean> = signal(false);

  /**
   * Un solo chunk contiene los 40 iconos: si falla la carga no hay ninguno, asi que quien pinte
   * iconos de configuracion debe caer a texto en lugar de dejar botones vacios.
   */
  public  readonly unavailable:  Signal<boolean>         = this._unavailable.asReadonly();

  private svgMap: Promise<Record<string, string>> | null = null;


  // METHODS
  public load(): Promise<Record<string, string>> {

    // Un chunk que no carga no debe dejar una rejection por instancia.
    this.svgMap ??= this.importLibrary()
      .catch((): Record<string, string> => {
        this._unavailable.set(true);
        return {};
      });

    return this.svgMap;

  }

  /** Punto de extension para los tests: es lo unico que toca la red. */
  protected importLibrary(): Promise<Record<string, string>> {
    return import('@models/types/components/VenueIcon.type')
      .then((module): Record<string, string> => module.VENUE_ICON_SVG);
  }

}
